import {stackBlurImage} from './library/StackBlur';
import {cart2sphere, inside, spher2CartCoord, sphere2equi} from "../../e3plan-3d/modules/libs/mathematics";
import EventEmitter from "../../helpers/EventEmmiter";

export default class BlurImg extends EventEmitter{
    _radius = 80;
    _blurAlphaChannel = false;
    _canvas = null;
    _image = null;

    constructor() {
        super();
        this._createCanvas();
    }

    // Draw the panorama once, blur every polygon into the same canvas,
    // encode a single JPEG Blob at the end (no per-polygon dataURL round-trip).
    async blurRectangles(image, rectangles){
        const canvas = this._canvas;
        let context;

        try{
            canvas.width = image.naturalWidth;
            canvas.height = image.naturalHeight;
            // CPU-backed canvas: avoids a GPU texture + readback copy on every getImageData.
            context = canvas.getContext('2d', {willReadFrequently: true});
            context.drawImage(image, 0, 0);
        }catch (e){
            throw "Can't create canvas " + e;
        }
        image = null;

        for (const points of rectangles) {
            await stackBlurImage(context, this._radius, this._blurAlphaChannel, points);
        }

        return this.toBlob();
    }

    toBlob(){
        return new Promise((res, rej) => {
            this._canvas.toBlob((blob) => {
                blob ? res(blob) : rej("Can't encode blurred image");
            }, 'image/jpeg', 1);
        });
    }

    _createCanvas(){
        this._canvas = document.createElement('canvas');
    }

    createImage(src){
        return new Promise((res, rej) => {
            const image = document.createElement('img');
            image.crossOrigin = "Anonymous";
            image.onload = () => {
                res(image);
            };
            image.onerror = (e) => {
                rej(e);
            };
            image.src = src;
        })
    }

    destroy(){
        if (this._canvas) {
            // Release the full-size backing store right away.
            this._canvas.width = 0;
            this._canvas.height = 0;
        }
        this._canvas = null;
        this._image = null;
    }
}
